import { lazy } from 'react';
import * as routes from 'constants/routes';

const ROLES = {
  SUPER_ADMIN: 'admin',
  CLIENT: 'client',
};

const AdminLoginPage = lazy(() => import('pages/auth/adminLogin'));
const ClientLoginPage = lazy(() => import('pages/auth/clientLogin'));
const ClientForgotPassword = lazy(() => import('pages/auth/forgotPassword'));
const ClientsListPage = lazy(() => import('pages/admin/clients/list/clientsList'));
const UsersListPage = lazy(() => import('pages/admin/users/usersList'));
const PageNotFoundPage = lazy(() => import('components/pageNotFound'));
const ExperiencesPage = lazy(() => import('pages/common/experience/list'));
const samplingExperience = lazy(() => import('pages/common/experience/sample'));
const ClientAddpage = lazy(() => import('pages/admin/clients/add'));
const AdminForgotPassword = lazy(() => import('pages/auth/forgotPassword'));
const UpdatePasswordPage = lazy(() => import('pages/auth/updatePassword'));
const ClientCompleteProfilePage = lazy(() => import('pages/client/profile/completeProfile'));
const SetDefaultRevenewSplitPage = lazy(() => import('pages/common/revenueSplit/DefaultSplit'));
const SetPromotionalRevenewSplitPage = lazy(() => import('pages/common/revenueSplit/PromotionSplit'));

const AddTreasureHunt = lazy(() => import('pages/common/experience/addEdit/addTreasureHunt'));
const AddGuidedTour = lazy(() => import('pages/common/experience/addEdit/addGuidedTour'));
const EditExperience = lazy(() => import('pages/common/experience/addEdit/editExperienceContainer'));
//common page self profile view and edit profile
const ProfilePage = lazy(() => import('pages/common/profile/userProfile'));
const ProfileEditPage = lazy(() => import('pages/common/editProfile/userEditProfile'));
const AdminClientProfilePage = lazy(() => import('pages/common/profile/clientProfile'));
const AdminClientProfileEditPage = lazy(() => import('pages/common/editProfile/clientEditProfile'));
const PaymentsPage = lazy(() => import('pages/common/payments/payments'));
const AdminPaymentsPage = lazy(() => import('pages/common/payments/AdminPayments'));

const AgreementPage = lazy(() => import('pages/common/agreementPage/agreementPage'));
const NotificationPageSm = lazy(() => import('pages/common/notificationSm/NotificationSm'));

const authRoutes = [
  {
    path: routes.ADMIN_LOGIN,
    exact: true,
    isNavbar: false,
    private: false,
    component: AdminLoginPage,
    redirect: routes.ADMIN_HOME,
  },
  {
    path: routes.CLIENT_LOGIN,
    exact: true,
    isNavbar: false,
    private: false,
    component: ClientLoginPage,
    redirect: routes.HOME,
  },
  {
    path: routes.CLIENT_FORGOT_PASSWORD,
    exact: true,
    isNavbar: false,
    private: false,
    component: ClientForgotPassword,
    redirect: routes.HOME,
  },
  {
    path: routes.ADMIN_FORGOT_PASSWORD,
    exact: true,
    isNavbar: false,
    private: false,
    component: AdminForgotPassword,
    redirect: routes.HOME,
  },
  {
    path: routes.CLIENT_INVITATION_LINK_LOGIN,
    exact: true,
    isNavbar: false,
    private: false,
    component: ClientLoginPage,
    redirect: routes.HOME,
  },
];

const AdminRoutes = [
  {
    path: routes.HOME,
    exact: true,
    isNavbar: true,
    private: true,
    redirect: routes.ADMIN_EXPERIENCES,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_HOME,
    exact: true,
    isNavbar: true,
    private: true,
    redirect: routes.ADMIN_EXPERIENCES,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_CLIENTS,
    exact: true,
    isNavbar: true,
    private: true,
    component: ClientsListPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.APP_USERS,
    exact: true,
    isNavbar: true,
    private: true,
    component: UsersListPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_ADD_CLIENT,
    exact: true,
    isNavbar: true,
    private: true,
    component: ClientAddpage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_EXPERIENCES,
    exact: true,
    isNavbar: true,
    private: true,
    component: ExperiencesPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.SAMPLE_EXPERIENCES,
    exact: true,
    isNavbar: true,
    private: true,
    component: samplingExperience,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.UPDATE_PASSWORD,
    exact: true,
    isNavbar: true,
    private: true,
    component: UpdatePasswordPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_PROFILE,
    exact: true,
    isNavbar: true,
    private: true,
    component: ProfilePage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_PROFILE_EDIT,
    exact: true,
    isNavbar: true,
    private: true,
    component: ProfileEditPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_CLIENT_PROFILE,
    exact: true,
    isNavbar: true,
    private: true,
    component: AdminClientProfilePage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_CLIENT_PROFILE_EDIT,
    exact: true,
    isNavbar: true,
    private: true,
    component: AdminClientProfileEditPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_SET_DEFAULT_REVENUE_SPLIT,
    exact: true,
    isNavbar: true,
    private: true,
    component: SetDefaultRevenewSplitPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_SET_PROMOTIONAL_REVENEW_SPLIT,
    exact: true,
    isNavbar: true,
    private: true,
    component: SetPromotionalRevenewSplitPage,
    permission: [ROLES.SUPER_ADMIN],
  },
  {
    path: routes.ADMIN_PAYMENT,
    exact: true,
    isNavbar: true,
    private: true,
    component: AdminPaymentsPage,
    permission: [ROLES.SUPER_ADMIN],
  },
];

const ClientRoutes = [
  {
    path: routes.HOME,
    exact: true,
    isNavbar: true,
    private: true,
    redirect: routes.CLIENT_EXPERIENCES,
    permission: [ROLES.CLIENT],
  },
  {
    path: routes.CLIENT_COMPLETE_PROFILE,
    exact: true,
    isNavbar: true,
    private: true,
    component: ClientCompleteProfilePage,
    redirect: routes.CLIENT_EXPERIENCES,
    permission: [ROLES.CLIENT],
  },
  {
    path: routes.CLIENT_EXPERIENCES,
    exact: true,
    isNavbar: true,
    private: true,
    component: ExperiencesPage,
    permission: [ROLES.CLIENT],
  },
  {
    path: routes.CLIENT_PROFILE,
    exact: true,
    isNavbar: true,
    private: true,
    component: ProfilePage,
    permission: [ROLES.CLIENT],
  },
  {
    path: routes.CLIENT_PROFILE_EDIT,
    exact: true,
    isNavbar: true,
    private: true,
    component: ProfileEditPage,
    permission: [ROLES.CLIENT],
  },
  {
    path: routes.CLIENT_PAYMENT,
    exact: true,
    isNavbar: true,
    private: true,
    component: PaymentsPage,
    permission: [ROLES.CLIENT],
  },
];

const commonRoutes = [
  {
    path: routes.NEW_GUIDED_TOUR,
    exact: true,
    isNavbar: true,
    private: true,
    component: AddGuidedTour,
    permission: [ROLES.CLIENT, ROLES.SUPER_ADMIN],
  },
  {
    path: routes.NEW_TREASURE_HUNT,
    exact: true,
    isNavbar: true,
    private: true,
    component: AddTreasureHunt,
    permission: [ROLES.CLIENT, ROLES.SUPER_ADMIN],
  },
  {
    path: routes.EDIT_EXPERIENCE,
    exact: true,
    isNavbar: true,
    private: true,
    component: EditExperience,
    permission: [ROLES.CLIENT, ROLES.SUPER_ADMIN],
  },
  {
    path: routes.PRIVACY_POLICY,
    exact: true,
    isNavbar: false,
    private: false,
    component: AgreementPage,
  },
  {
    path: routes.NOTIFICATION_SM,
    exact: true,
    isNavbar: true,
    private: false,
    component: NotificationPageSm,
  },
  {
    path: routes.LICENSING_AGREEMENT,
    exact: true,
    isNavbar: false,
    private: false,
    component: AgreementPage,
  },
  {
    path: routes.PAGE_NOT_FOUND,
    exact: false,
    isNavbar: false,
    private: false,
    component: PageNotFoundPage,
    redirect: routes.CLIENT_LOGIN,
  },
];

const routesConfig = [...authRoutes, ...AdminRoutes, ...ClientRoutes, ...commonRoutes];

export default routesConfig;
